import {
  DELETE_GROUP_ERROR,
  DELETE_GROUP_START,
  DELETE_GROUP_SUCCESS,
} from 'constants/action-types/organizations/deleteGroup';

export default (state, { type, payload }) => {
  switch (type) {
    case DELETE_GROUP_START:
      return {
        ...state,
        deleteGroup: {
          ...state.deleteGroup,
          loading: true,
          error: null,
          message: null,
        },
      };
    case DELETE_GROUP_SUCCESS:
      return {
        ...state,
        deleteGroup: {
          ...state.deleteGroup,
          loading: false,
          error: null,
          message: payload.data,
        },
      };
    case DELETE_GROUP_ERROR:
      return {
        ...state,
        deleteGroup: {
          ...state.deleteGroup,
          loading: false,
          message: null,
          error: payload,
        },
      };
    default:
      return null;
  }
};
